import React from 'react';
import ImpactDashboard from "../common/components/impact/ImpactDashboard";
import { useLocation } from "react-router-dom";
import '../common/css/global.css';
import './App.css'

const App = () => {

  const location = useLocation();

  const merchantCode = location.pathname.split('/')[1];

  return (
    <>
      <ImpactDashboard merchantCode={merchantCode ? merchantCode : 'ALL'}/>
    </>
  );
}

export default App;
